<template>
    <div class="relative mt-6">
        <button :class="`bg-white p-3 rounded-lg relative z-50 ${shake ? 'shake' : ''}`" @click="open = !open">
            <div
                class="absolute top-0 right-0 bg-red h-2 w-2 rounded-full mt-3 mr-3"
                v-show="hasUnreadNotification"
            ></div>
            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.23545 12.5546L3.28438 11.5038C3.6204 11.1678 3.80529 10.7216 3.80529 10.2469V6.08939C3.80529 4.88312 4.32976 3.73018 5.24536 2.92837C6.16806 2.11944 7.34323 1.76387 8.56728 1.92477C10.6358 2.19945 12.1959 4.06975 12.1959 6.27607V10.2469C12.1959 10.7216 12.3808 11.1678 12.7159 11.503L13.7657 12.5546H2.23545ZM9.77799 14.6355C9.77799 15.4347 8.96373 16.1103 8.00013 16.1103C7.03653 16.1103 6.22228 15.4347 6.22228 14.6355V14.3324H9.77799V14.6355ZM15.5747 11.8505L13.9738 10.2469V6.27607C13.9738 3.18171 11.7497 0.553154 8.80019 0.162915C7.09167 -0.0646504 5.36715 0.45715 4.07376 1.59142C2.77237 2.73103 2.02745 4.37021 2.02745 6.0894L2.02656 10.2469L0.425606 11.8505C0.00869908 12.2683 -0.114862 12.8897 0.110926 13.4346C0.337602 13.9804 0.864736 14.3324 1.45498 14.3324H4.44445V14.6355C4.44445 16.4294 6.03918 17.8881 8.00016 17.8881C9.96113 17.8881 11.5559 16.4294 11.5559 14.6355V14.3324H14.5453C15.1356 14.3324 15.6618 13.9804 15.8876 13.4355C16.1143 12.8897 15.9916 12.2674 15.5747 11.8505Z"
                    fill="#7B1E7A"
                />
            </svg>
        </button>
        <div
            @click="closeNotification"
            :class="
                `w-screen fixed background top-0 left-0 duration-500 ${
                    open ? 'opacity-100 h-screen ' : 'opacity-0 h-0'
                }`
            "
        ></div>
        <div
            :class="
                `absolute  right-0 transform duration-500 ${
                    open ? 'opacity-100 translate-y-0 pt-6' : ' -translate-y-4 opacity-0 z- h-0'
                }`
            "
        >
            <div :class="`bg-white rounded-lg notification-width overflow-auto ${open ? 'notifications py-6' : 'h-0'}`">
                <div class="flex items-center justify-between px-6">
                    <div>
                        <p class="text-grey-300 text-xs">NOTIFICATIONS</p>
                    </div>
                    <div>
                        <button @click="closeNotification">
                            <span class="text-2xl text-smoke-dark cursor-pointer" aria-label="close">&times;</span>
                        </button>
                    </div>
                </div>
                <template v-if="notifications.length">
                    <div class="flex justify-end">
                        <button
                            @click="clearNotifications"
                            class="rounded-full px-4 py-1 bg-snow-200 mr-3 mt-3 hover:bg-purple duration-500 hover:text-white text-smoke-dark"
                        >
                            <p class="text-xs">Clear</p>
                        </button>
                    </div>
                    <ul class="mt-1">
                        <li
                            :class="
                                `py-8 ${notification.seen ? '' : 'bg-purple-pale'}  ${
                                    i < notifications.length ? 'border-b border-snow-200' : ''
                                } ${i === 0 ? 'pt-4' : ''} px-6 relative`
                            "
                            v-for="(notification, i) in notifications"
                            :key="i"
                        >
                            <div
                                class="w-2 h-2 rounded-full bg-purple absolute top-0 right-0 mt-5 mr-6"
                                v-show="!notification.seen"
                            ></div>
                            <h5 class="text-sm text-purple-base">{{ notification.title }}</h5>
                            <p
                                class="text-xs text-smoke-dark mt-3"
                                v-html="
                                    notification.body +
                                        `${
                                            notification.type === 1
                                                ? '<br />This transaction will expire in the next 30 mins if no action is performed on it'
                                                : ''
                                        }`
                                "
                            ></p>
                            <p class="mt-2 text-xs text-smoke-dark font-medium">
                                {{ getNotificationDate(notification.created_at) }}
                            </p>
                        </li>
                    </ul>
                </template>
                <template v-else>
                    <div
                        :class="
                            `flex flex-col items-center justify-center mt-24 duration-1000 transform ${
                                open ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'
                            }`
                        "
                    >
                        <svg
                            width="120"
                            height="120"
                            viewBox="0 0 120 120"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M85.7699 45.6326L58.3619 81.6326C57.2339 83.1146 55.4879 83.9906 53.6279 84.0026H53.5859C51.7439 84.0026 50.0039 83.1506 48.8639 81.6986L34.2719 63.0566C32.2319 60.4526 32.6879 56.6786 35.2979 54.6386C37.9019 52.5926 41.6819 53.0486 43.7219 55.6646L53.5199 68.1806L76.2239 38.3666C78.2279 35.7326 81.9899 35.2166 84.6359 37.2266C87.2699 39.2366 87.7799 42.9986 85.7699 45.6326ZM60 0C26.862 0 0 26.862 0 60C0 93.132 26.862 120 60 120C93.138 120 120 93.132 120 60C120 26.862 93.138 0 60 0Z"
                                fill="#E5E9F2"
                            />
                        </svg>
                        <div class="mt-4 w-10/12 mx-auto text-center">
                            <p class="text-purple-base font-semibold text-base mt-5">You’re all caught up!</p>
                            <p class="text-xs text-grey-300 mt-3">
                                You will recieve transactional notifications here
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    data() {
        return {
            open: false,
            shake: false,
        }
    },

    computed: {
        ...mapGetters('Notification', {
            notifications: 'GET_NOTIFICATIONS',
        }),

        hasUnreadNotification: function() {
            let hasUnread = false
            for (let i = 0; i < this.notifications.length; i += 1) {
                if (!this.notifications[i].seen) {
                    hasUnread = true
                    break
                }
            }

            return hasUnread
        },
    },

    watch: {
        notifications: {
            handler() {
                this.shake = true
                setTimeout(() => {
                    this.shake = false
                }, 1000)
            },
        },
    },

    methods: {
        closeNotification() {
            this.open = false

            for (let i = 0; i < this.notifications.length; i += 1) {
                this.notifications[i].seen = true
            }
            localStorage.setItem('notifications', JSON.stringify(this.notifications))
        },

        getNotificationDate(created_date) {
            const date = new Date(created_date)

            return `${date.getDate()}/${date.getMonth()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`
        },

        ...mapMutations('Notification', {
            clearNotificationsMutation: 'COMMIT_CLEAR_NOTIFICATIONS',
        }),

        clearNotifications() {
            // this.open = false
            this.clearNotificationsMutation()
        },
    },
}
</script>

<style scoped>
.notifications {
    height: 580px;
}

.notification-width {
    width: 350px;
}

.background {
    background: rgba(60, 25, 82, 0.1);
    backdrop-filter: blur(3px);
}

@media screen and (max-width: 320px) {
    .notifications {
        margin: auto;
        height: auto;
    }

    .notification-width {
        width: 290px;
    }
}

.z- {
    z-index: -999;
}

.shake {
    animation: shake 500ms ease-in-out infinite normal both;
}

@keyframes shake {
    0%,
    100% {
        transform: rotate(45deg);
    }

    50% {
        transform: rotate(0deg);
    }
}
</style>
